// 和暦用
export var japan_date_default = {
    calendar: [
        { value: '1', label: '令和' },
        { value: '2', label: '平成' },
        { value: '3', label: '昭和' },
        { value: '4', label: '大正' },
        { value: '5', label: '明治' },
    ],
    year: '2020',
    month: '1',
    date: '1',
};
// 棚種別
export var shelf_type = {
    header: 1,
    shelf: 2,
    layout_divisiton: 3,
    fragment: 4,
    footer: 5,
    full_justify_buttons: 6,
    left_button: 7,
    center_button: 8,
    right_button: 9,
    justify_buttons: 10,
    left_and_right_alignment_buttons: 11,
    documents: 21,
};
// 同意文の種別
// 1.マイページ開設
// 2.個人情報取り扱い
// 3.反社会的勢力でない
export var clauses_type_list = [1, 2, 3];
// True,False
export var checked_on = true;
export var checked_off = false;
// 商品選択画面のパス
export var product_image_path = process.env.MIX_MOCK_FILEURL + "/img/product_list/";
// 商品選択画面の画像パス
export var overview_step_img = process.env.MIX_MOCK_FILEURL + "/img/product_list/overview_step.png";
export var ahead_step_img = process.env.MIX_MOCK_FILEURL + "/img/product_list/ahead_step.png";
export var main_step_img = process.env.MIX_MOCK_FILEURL + "/img/product_list/main_step.png";
export var contract_step = process.env.MIX_MOCK_FILEURL + "/img/product_list/contract_step.png";
export var contract_step_icon = process.env.MIX_MOCK_FILEURL + "/img/product_list/contract_step_icon.png";
export var file_icon = process.env.MIX_MOCK_FILEURL + "/img/product_list/file_icon.png";
// 一時変数の初期値
export var tmp_init = {
    key: '',
    pb_id: 0,
    cb_id: 0,
    fm_id: 0,
    is_send_parent: false,
    fm_display_name: '',
    required_mark: false,
    field_column_name: '',
    fm_type: '',
    placeholder: '',
    function: '',
    message: '',
    value: '',
    suffix: '',
    sources: [{ key: '', value: '', checked: false }],
    help_msg: '',
    disabled: false,
    readonly: false,
    bold: false,
    color: '',
    dialog: false,
    dialog_title: '',
    dialog_msg: '',
    dialog_is_open: false,
    input_assistance: '',
    maxlength: 0,
};
// 応答ダイアログの初期値
export var dialog_init = {
    is_confirm: false,
    show: false,
    title: '',
    body: '',
};
// 応答ダイアログの種別
export var dialog_type = {
    confirm: '1',
    yes_no: '2',
};
// 応答ダイアログのファンクション位置
export var dialog_function = {
    confirm: 0,
    yes: 1,
    no: 2,
};
// 排他情報の初期値
export var exclusion_init = {
    is_banker: false,
    is_locked: false,
    user_name: '',
    locked_at: '',
};
// pdfのアイコン
export var pdf_icon = process.env.MIX_MOCK_URL + "/images/pdf_icon.png";
// APIからの応答種別
export var api_response_type = {
    page_transition: 0,
    dialog: 1,
    validation: 2,
    list: 3,
    auto_input: 4,
    auto_input_all: 5,
    transition_to_list: 9,
    transition_to_mypage: 10,
    download: 11,
    transition_to_mypage_complete: 12,
    err_msg: 13, // エラーメッセージ
};
/**
 * 値変換種別
 */
export var convert_types = {
    add_comma: 'addComma',
    change_numeric: 'cngNumeric',
    change_alpha_numeric: 'cngAlphaNumeric',
    change_alpha_numeric_symbol: 'changeAlphaNumericSymbol',
    change_zenkaku_kana: 'cngZenkakuKana',
    change_hankaku_kana: 'cngHankakuKana',
    add_decimal_point: 'addDecimalPoint',
    change_zenkaku: 'cngZenkaku',
    change_account_holder_zenkakuKana: 'cngAccountHolderZenkakuKana',
    serial_number: 'serialNumber',
    change_hyphen_to_slash: 'cngHyphenToSlash',
    change_upper_alpha_numeric: 'changeUpperAlphaNumeric',
    change_upper_alpha_numeric_symbol: 'changeUpperAlphaNumericSymbol',
};
/**
 * フィールドマスタのタイプ
 */
export var fm_types = {
    text: 'TEXT',
    number: 'NUMBER',
    not_yet_text: 'NOT_YET_TEXT',
    year: 'YEAR',
    month: 'MONTH',
    pincode: 'PINCODE',
    date: 'DATE',
    button: 'BUTTON',
    postcode: 'POSTCODE',
    telnumber: 'TELNUMBER',
    sei: 'SEI',
    mei: 'MEI',
    radio: 'RADIO',
    checkbox: 'CHECKBOX',
    select: 'SELECT',
    textarea: 'TEXTAREA',
    paragraph: 'PARAGRAPH',
    paragraph2: 'PARAGRAPH2',
    link: 'LINK',
    image: 'IMAGE',
    items: 'ITEMS',
    business_date: 'BUSINESSDATE',
    after_specified_date: 'AFTERSPECIFIEDDATE',
    datalist: 'DATALIST',
    text_with_search: 'TEXTWITHSEARCH',
    password_reset: 'PASSWORDRESET',
    se_country_select: 'SE_COUNTRY_SELECT',
    single_select: 'SINGLE_SELECT',
};
/**
 * 数値変換対象
 */
export var to_numeric_type = [fm_types.number, fm_types.year, fm_types.pincode];
/**
 * UTF文字コード（UTF-16 BE）
 */
export var utf_code = {
    zenkaku_numeric_start: 0xff10,
    zenkaku_numeric_end: 0xff19,
    zenkaku_numeric_convert: 0xfee0,
    zenkaku_hiragana_start: 0x3041,
    zenkaku_hiragana_end: 0x3093,
    zenkaku_hiragana_convert: 0x0060,
    hankaku_dakuten: 0xff9e,
    hankaku_handakuten: 0xff9f, // 半角ｶﾅの半濁点の文字コード
};
/**
 * ダウンロード対象のファイル種別
 */
export var content_type = {
    pdf: 'application/pdf',
    csv: 'text/csv',
};
/**
 * 変換文字
 */
export var convert_char = {
    hankaku_kana: '｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ ',
    hankaku_kana_dakuon_base: 'ｳｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾊﾋﾌﾍﾎ',
    hankaku_kana_handakuon_base: 'ﾊﾋﾌﾍﾎ',
    hankaku_kana_dakuten: 'ﾞ',
    hankaku_kana_handakuten: 'ﾟ',
    zenkaku_kana: '。「」、・ヲァィゥェォャュョッーアイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワン　',
    zenkaku_kana_dakuon: 'ヴガギグゲゴザジズゼゾダヂヅデドバビブベボ',
    zenkaku_kana_handakuon: 'パピプペポ',
    zenkaku_hiragana: '。「」、・をぁぃぅぇぉゃゅょっーあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわん　',
    zenkaku_hiragana_dakuon: 'ゔがぎぐげござじずぜぞだぢづでどばびぶべぼ',
    zenkaku_hiragana_handakuon: 'ぱぴぷぺぽ',
    hankaku_space: ' ',
    zenkaku_space: '　',
    hankaku_backslash: /\\/g,
    zenkaku_backslash: '￥',
    zenkaku_numeric_base: '１２３４５６７８９０',
    hankaku_numeric_base: '1234567890',
    zenkaku_alphabet_base: 'ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚＡＢＣＤＥＦＧＨＩＪＫＭＬＮＯＰＱＲＳＴＵＶＷＸＹＺ',
    hankaku_alphabet_base: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKMLNOPQRSTUVWXYZ',
};
/**
 * HTTPステータスコード
 */
export var http_status = {
    ok: 200,
    created: 201,
};
/**
 * モジュール名
 */
export var module_name = {
    mypage_open: 'S4000N001MypageOpen',
    form_output: 'S070N001FormOutput',
    // TODO sakuma CSV登録用のファンクション。名称決まり次第定義
    import_subscription: 'test_module',
    new_registration: 'NewRegistration',
    new_registration_se: 'NewRegistrationSe',
    csv_registration_product_japanese: 'CsvRegistrationProductJapanese',
    csv_registration_product_english: 'CsvRegistrationProductEnglish',
    csv_registration_dc_japanese: 'CsvRegistrationDcJapanese',
    csv_registration_dc_english: 'CsvRegistrationDcEnglish',
    csv_dc_shipping: 'CsvDcShipping ',
    csv_no_shipping: 'CsvNoShipping ',
    csv_received_back: 'CsvReceivedBack ',
    read_qrcode: 'ReadQrcode',
    reset_password: 'ResetPassword',
    remark: 'RemarksRegistration',
    csv_registration_corporate_sales: 'CsvRegistrationCorporateSales',
    csv_registration_se: 'CsvRegistrationSe',
    csv_received_back_se: 'CsvReceivedBackSe', // CSV削除(SE)
};
/**
 * モジュール名(印刷機能)
 */
export var module_name_for_print = [
    { key: 'download_letter_of_thanks', value: 'DownloadLetterOfThanks' },
    { key: 'download_Warranty_information', value: 'DownloadWarrantyInformation' },
    { key: 'download_registration_information', value: 'DownloadRegistrationInformation' },
    { key: 'download_back_sticker', value: 'DownloadBackSticker' },
    { key: 'download_destination_sticker', value: 'DownloadDestinationSticker' },
    { key: 'download_bulk', value: 'DownloadBulk' },
    { key: 'download_check_list', value: 'DownloadCheckList' }, //チェックリスト印刷
];
/**
 * バリデーション用の結合文字列
 * Note : ボタン押下時のバリデーション対象が複数項目だった場合に使用
 */
export var valid_merge_index = '-0';
/**
 * スクロール位置調整用オプション
 */
export var scroll_option = {
    validation: -70,
    next_shelf: 0,
};
/*
 * pdfダウンロード時のwaitタイム(ミリ秒)
 */
export var download_wait_time = 3000;
export var test_person = [
    { type: '1', key: '0', value: '' },
    { type: '1', key: '1', value: '免許証' },
    { type: '1', key: '2', value: '保険証' },
    { type: '1', key: '3', value: '住民票' },
];
export var test_certification = [
    { type: '2', key: '0', value: '' },
    { type: '2', key: '1', value: '証明A' },
    { type: '2', key: '2', value: '証明B' },
    { type: '2', key: '3', value: '証明C' },
];
export var test_document = [
    { type: '3', key: '0', value: '' },
    { type: '3', key: '1', value: '収集同意書' },
    { type: '3', key: '2', value: '保有同意書' },
    { type: '3', key: '3', value: '利用同意書' },
    { type: '3', key: '4', value: '提供同意書' },
];
// ファイルアップロード, バリデーション初期状態
export var valid_init_state = {};
// ファイルアップロード_初期ステータス（申込人）
export var person_initialState = [
    {
        name: 0,
        title: '本人確認資料',
        default_value: '1',
        shelf_cd: 'A',
        source: test_person,
        preview_file_src: '',
        file_label: '',
        is_loading: false,
        loading_msg: '',
        is_add: true,
        is_staff: true,
        is_uploaded: false,
        file_upload_date: '2021/01/08',
        confirm_date: '',
        confirm_user: '',
        file: new Blob(),
        valid_messages: valid_init_state,
        is_modal_show: false,
        file_upload_name: '',
        file_status: '',
        is_pdf: false,
    },
];
export var certification_initialState = [
    {
        name: 1,
        title: '所得証明',
        default_value: '2',
        shelf_cd: 'B',
        source: test_certification,
        preview_file_src: '',
        file_label: '',
        is_loading: false,
        loading_msg: '',
        is_add: true,
        is_staff: true,
        is_uploaded: false,
        file_upload_date: '2021/01/08',
        confirm_date: '',
        confirm_user: '',
        file: new Blob(),
        valid_messages: valid_init_state,
        is_modal_show: false,
        file_upload_name: '',
        file_status: '',
        is_pdf: false,
    },
];
export var document_initialState = [
    {
        name: 2,
        title: '物件資料',
        default_value: '3',
        shelf_cd: 'B',
        source: test_document,
        preview_file_src: '',
        file_label: '',
        is_loading: false,
        loading_msg: '',
        is_add: true,
        is_staff: false,
        is_uploaded: false,
        file_upload_date: '2021/01/08',
        confirm_date: '',
        confirm_user: '',
        file: new Blob(),
        valid_messages: valid_init_state,
        is_modal_show: false,
        file_upload_name: '',
        file_status: '',
        is_pdf: false,
    },
];
// ファイルアップロード_初期ステータス（職員）
export var person_initialState_staff = [
    {
        name: 3,
        title: '本人確認資料',
        default_value: '0',
        shelf_cd: 'C',
        source: test_person,
        preview_file_src: '',
        file_label: '',
        is_loading: false,
        loading_msg: '',
        is_add: true,
        is_staff: true,
        is_uploaded: false,
        file_upload_date: '',
        confirm_date: '',
        confirm_user: '',
        file: new Blob(),
        valid_messages: valid_init_state,
        is_modal_show: false,
        file_upload_name: '',
        file_status: '',
        is_pdf: false,
    },
];
export var certification_initialState_staff = [
    {
        name: 4,
        title: '所得証明',
        default_value: '0',
        shelf_cd: 'D',
        source: test_certification,
        preview_file_src: '',
        file_label: '',
        is_loading: false,
        loading_msg: '',
        is_add: true,
        is_staff: true,
        is_uploaded: false,
        file_upload_date: '',
        confirm_date: '',
        confirm_user: '',
        file: new Blob(),
        valid_messages: valid_init_state,
        is_modal_show: false,
        file_upload_name: '',
        file_status: '',
        is_pdf: false,
    },
];
export var document_initialState_staff = [
    {
        name: 5,
        title: '物件資料',
        default_value: '0',
        shelf_cd: 'I',
        source: test_document,
        preview_file_src: '',
        file_label: '',
        is_loading: false,
        loading_msg: '',
        is_add: true,
        is_staff: true,
        is_uploaded: false,
        file_upload_date: '',
        confirm_date: '',
        confirm_user: '',
        file: new Blob(),
        valid_messages: valid_init_state,
        is_modal_show: false,
        file_upload_name: '',
        file_status: '',
        is_pdf: false,
    },
];
// チェックボックス用
export var check_test_source = [
    { key: '1', value: 'テストValue1', checked: false },
    { key: '2', value: 'テストValue2', checked: true },
    { key: '3', value: 'テストValue3', checked: false },
];
// SelectBoxの配列
export var select_test_source = [
    { key: '0', value: 'Select Value1', checked: false },
    { key: '1', value: 'Select Value2', checked: false },
    { key: '2', value: 'Select Value3', checked: false },
    { key: '3', value: 'Select Value4', checked: false },
];
// ラジオボタンの仮値
export var radio_test_source = [
    { key: '0', value: 'ラジオValue1', checked: false },
    { key: '1', value: 'ラジオValue2', checked: false },
    { key: '2', value: 'ラジオValue3', checked: false },
    { key: '3', value: 'ラジオValue4', checked: false },
];
// 年月表示部品テスト用
export var years_source = {
    years: [
        { key: '1', value: '0', checked: false },
        { key: '2', value: '1', checked: false },
        { key: '3', value: '2', checked: false },
        { key: '4', value: '3', checked: false },
        { key: '5', value: '4', checked: false },
        { key: '6', value: '5', checked: false },
        { key: '7', value: '6', checked: false },
        { key: '8', value: '7', checked: false },
        { key: '9', value: '8', checked: false },
        { key: '10', value: '9', checked: false },
    ],
    months: [
        { key: '1', value: '0', checked: false },
        { key: '2', value: '1', checked: false },
        { key: '3', value: '2', checked: false },
        { key: '4', value: '3', checked: false },
        { key: '5', value: '4', checked: false },
        { key: '6', value: '5', checked: false },
        { key: '7', value: '6', checked: false },
        { key: '8', value: '7', checked: false },
        { key: '9', value: '8', checked: false },
        { key: '10', value: '9', checked: false },
        { key: '11', value: '10', checked: false },
        { key: '12', value: '11', checked: false },
    ],
};
// モック用の固定値
export var login_date = '2020/11/09 11:11:11';
export var login_user = '融資 太郎';
export var shelf_cd_list = {
    identification_1: 'A',
    identification_2: 'B',
};
export var file_upload_label = {
    identification: '書類の提出',
};
export var email_domain = 'xxxxxxx.com';
// 本人確認書類の画像イメージの設定
export var compressor_option = {
    quality: 1,
    max_height: 1920,
    max_width: 1080,
    preview_max_height: 300,
    preview_max_width: 300,
};
// 本人確認書類のプレビュー画像イメージの設定
export var preview_option = {
    reduction_rate_pc: 0.7,
    reduction_rate_sp: 0.7,
};
export var file_type_error = {
    file: ['ファイルにはpdf,bmp,jpeg,jpg,png,gifタイプのファイルを指定してください。'],
};
export var file_upload_error = {
    file: ['ファイルアップロードに失敗しました'],
};
// ファイルアップロード情報の初期値
export var file_upload_info_init = {
    reception: {
        ident_lv1_cd: '',
        ident_lv2_cd: '',
        ident_lv3_cd: '',
        reception_id: 0,
        reception_cd: '',
        reception_sub_cd: '',
    },
    attention: '',
};
// ファイルアップロード ラベルの省略設定
export var file_upload_clamp_config = {
    length: 18,
    clamp_string: '...',
};
//入力支援(桁埋め)の追加文字列
export var assist_digit = '0000000000';
//入力支援(桁埋め)の追加文字列
export var serial_number_digit = '000000';
//テキストエリアのデフォルト行数
export var textarea_default_row = 3;
//案件一覧 検索パラメータの初期値
export var search_params_init = {
    guaranty_number: '',
    status: new Array(),
    brand: '',
    watch_reference: '',
    serial_number: '',
    local_no: '',
    caliber: '',
    case: '',
    how_to_register: new Array(),
    country: '',
    no_code: '',
    shipment_store_code: '',
    select_date_type: '',
    from_date_at: '',
    to_date_at: '',
    store_code: '',
    first_name: '',
    last_name: '',
    first_name_kana: '',
    last_name_kana: '',
    telephone_number: '',
    email: '',
    account_or_shop_code: '',
};
//案件一覧 新規作成のブランド選択の初期値
export var new_registration_brand_init = {
    brand: 'GS',
};
// stl権限が扱えるブランド
export var operation_with_stl_use_brand = ['GL', 'IZ', 'SE'];
//案件履歴 検索パラメータの初期値
export var reception_history_search_params_init = {
    from_update_at: '',
    to_update_at: '',
    update_user_type: new Array(),
    update_name: '',
    status: '',
    item_name: '',
    item_old_value: '',
    item_new_value: '',
};
//ログ一覧 検索パラメータの初期値
export var log_search_params_init = {
    created_at_from_ymd: '',
    created_at_from_hour: '',
    created_at_from_minute: '',
    created_at_to_ymd: '',
    created_at_to_hour: '',
    created_at_to_minute: '',
    error_level: '',
    message_code: '',
    message: '',
    reception_cd: '',
    reception_sub_cd: '',
    operation: '',
    src_address: '',
};
// 営業日カレンダーの設定
export var business_day_calendar = {
    min_date: 3,
    max_year: 1, // 選択可能な日付の最大年数
};
// DatepickerJpの設定
export var datepicker_jp = {
    year_from: 11,
    year_to: 101, // N年前の過去年を表示する
};
// 案件一覧 projectオブジェクトから呼び出すデータのindexを指定する
export var project_list_staff_read_index = {
    reception_cd: 1,
    reception_id: 30,
    status: 31,
    no_reception_id: 32,
    no_status: 33, // NO権限時案件ステータス
};
// 案件一覧 projectオブジェクトから呼び出すデータのindexを指定する(NO権限以外)
export var project_list_staff_read_index_not_no = {
    reception_cd: 1,
    reception_id: 9,
    status: 10, // 案件ステータス
};
// 案件一覧 projectオブジェクトから呼び出すデータのindexを指定する(NO権限)
export var project_list_staff_read_index_no = {
    reception_cd: 1,
    reception_id: 32,
    status: 33, // 案件ステータス
};
// 案件一覧 projectオブジェクトから呼び出すデータのindexを指定する(SE権限)
export var project_list_staff_read_index_se = {
    reception_cd: 1,
    reception_id: 10,
    status: 11, // 案件ステータス
};
// 案件一覧 projectオブジェクトから呼び出すデータのindexを指定する(SEIKOの海外NO連携権限)
export var project_list_staff_read_index_se_no = {
    reception_cd: 1,
    reception_id: 9,
    status: 10, // 案件ステータス
};
// ショップ因子 storesオブジェクトから呼び出すデータのindexを指定する
export var stores_list_read_index = {
    fcshin: 1,
    fctfbi: 2,
    fctsbi: 3,
    id: 4, // id
};
// 販売店一覧 オブジェクトから呼び出すデータのindexを指定する
export var store_list_index = {
    store_number: 1,
    store_name: 9, // 販売店名
};
// 販売店一覧 オブジェクトから呼び出すデータのindexを指定する
export var no_store_list_index = {
    id: 0,
    parent_cd: 1,
    no_code: 2,
    d_code: 3, // D-CODE(旧NOコード)
};
// マスク文字列
export var mask_string = '●';
//申込人案件一覧画面の商品概要のリンク
export var product_summary_link = '';
//ローディング画面非表示時のタイマー設定
export var loding_close_timmer = 5000;
//案件履歴画面ヘッダー初期値
export var header_info_init = {
    application_product: '',
    is_history: true,
    is_staff: true,
    reception_cd: '',
    status_code: 0,
    status_name: '',
    user_name: '',
};
// 時コントロール選択項目
export var hours = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
];
// 分コントロール選択項目
export var minutes = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
];
//ユーザメンテナンス詳細パラメータの初期値
export var user_params_init = {
    first_name: '',
    last_name: '',
    first_kana: '',
    last_kana: '',
    office_id: '0',
    role_id: '0',
    email: '',
    password: '',
    del_flg: 'false',
    realsys_acc_flag: 'false',
    password_email_destination: '',
};
//ユーザメンテナンス詳細パラメータの初期値
export var radio_button_boolean_flg_init = [
    { key: '有効', value: 'true' },
    { key: '無効', value: 'false' },
];
//ユーザメンテナンス検索パラメータの初期値
export var user_search_params_init = {
    name: '',
    email: '',
    office_id: '',
};
//販売店メンテナンス検索パラメータの初期値
export var store_search_params_init = {
    target_bland: '',
    store_code: '',
    shop_factor: '0',
    factor_all_selected_flg: true,
    factor: ['GSB', 'GSS', 'GSMS', 'GS', 'CRSA', 'CRSB', 'GS9'],
    name_kanji: '',
    phone_number: '',
    address: '',
    from_update_at: '',
    to_update_at: '',
    update_user_code: '',
};
//NO販売店メンテナンス検索パラメータの初期値
export var no_store_search_params_init = {
    parent_cd: '',
    no_cd: '',
    d_code: '',
    shop_cd: '',
    shop_factor: [],
    no_supervision: '',
};
/** NO店舗マスターショップ因子の検索パラメータの初期値 */
export var no_store_factor_search_params_init = {
    factor_all_selected: '0',
    factor_all_selected_flg: false,
    factor: ['GSB', 'GSS', 'GSMS', 'Others'],
};
//ショップ因子の検索パラメータの初期値
export var store_factor_search_params_init = {
    factor_all_selected: '0',
    factor_all_selected_flg: false,
    factor: ['GSB', 'GSS', 'GSMS', 'GS', 'CRSA', 'CRSB', 'GS9', 'SPB', 'PWS', 'GA'],
};
//ショップ因子の更新パラメータの初期値
export var store_factor_update_params_init = {
    factor: 'SPB',
    from_update_at: '',
    to_update_at: '',
};
/** NO店舗マスターショップ因子の更新パラメータの初期値 */
export var no_store_factor_update_params_init = {
    factor: 'GSS',
    from_update_at: '',
    to_update_at: '',
};
export var post_data_init = {
    reception_id: null,
    reception_cd: null,
    module_name: '',
    detail: [],
    is_json: true,
};
//販売店コード、営業グループ、担当セールスの初期値
export var config_init = {
    shop_code: '',
    sales_group: '',
    sales_staff: '',
};
/** NO店舗マスターNO統括,D-CODE1,販売店コード,販売店名 */
export var no_store_config_init = {
    no_toukatu: '',
    d_code1: '',
    retailer_cd: '',
    no_name: '',
    country: '',
    city: '',
};
export var country_options_init = [
    { key: '', value: '' },
];
//更新履歴の初期値
export var update_history_init = [
    { key: '登録件数', value: '' },
    { key: '登録日', value: '' },
    { key: '最終更新日', value: '' },
    { key: '最終更新者', value: '' },
];
//更新履歴の初期値
export var select_brand_init = [
    { key: 'Crest', value: 'Crest' },
    { key: 'Grand', value: 'Grand' },
    { key: 'Gala', value: 'Gala' },
    { key: 'Izul', value: 'Izul' },
    { key: 'Smap', value: 'Smap' },
];
//検索結果一覧の初期値
export var number_of_search_init = [
    { key: '検索件数', value: '' },
    { key: '登録件数', value: '' },
];
//店舗マスター(新規作成画面)のパラメータの初期値
export var store_params_init = {
    target_brand: '',
    store_code: '',
    sales_group: '',
    sales_staff: '',
    store_name: '',
    post_code: '',
    store_address: '',
    phone_number: '',
    business_category: '',
    individual_store_code: '',
    individual_store_name: '',
    corporation_code: '',
    corporation_name: '',
    official_name: '',
    official_post_code: '',
    official_address: '',
    official_phone_number: '',
    shop_factor: '',
    customer_rank: '',
    postcard_input_check_word: '',
    memo: '',
};
//NO販売店情報登録更新画面のパラメータの初期値
export var no_store_params_init = {
    id: '',
    no_supervision: '',
    parent_cd: '',
    no_cd: '',
    no_name: '',
    country: '',
    city: '',
    create_user: '',
    created_at: '',
    update_user: '',
    updated_at: '',
};
//店舗マスター(新規作成画面)のパラメータの初期値
export var store_option_init = {
    target_brand: [],
};
// 言語選択
export var langugages = [
    { key: 'lang/en', value: 'English' },
    { key: 'lang/ja', value: '日本語' },
];
// 言語選択
export var selected_langugage = {
    english: 'en',
    japanese: 'ja',
};
// ロールによるボタン制御の初期値
export var button_disp_statuses_init = {
    new_registration: false,
    csv_registration_product_ja: false,
    csv_registration_product_en: false,
    csv_registration_dc_ja: false,
    csv_registration_dc_en: false,
    csv_dc_shipping: false,
    csv_no_shipping: false,
    csv_received_back: false,
    read_qrcode: false,
    csv_registration_corporate_sales: false,
    csv_registration_se: false,
    csv_received_back_se: false,
};
//ブランドの初期値
export var checkbox_brand_name = [
    { key: 'GSB', value: 'GSB' },
    { key: 'GSS', value: 'GSS' },
    { key: 'GSMS', value: 'GSMS' },
    { key: 'GS', value: 'GS' },
    { key: 'CRSA', value: 'CRSA' },
    { key: 'CRSB', value: 'CRSB' },
    { key: 'GS9', value: 'GS9' },
];
/** NO店舗マスターブランドの初期値 */
export var no_store_checkbox_brand_name = [
    { key: 'GSB', value: 'GSB' },
    { key: 'GSS', value: 'GSS' },
    { key: 'GSMS', value: 'GSMS' },
    { key: 'Others', value: 'Others' },
];
//ラジオボタンの初期値
export var radio_button_name = [
    { key: '0', value: '全て' },
    { key: '1', value: '個別' },
];
//ショップ因子の入力項目ブランドの初期値
export var checkbox_brand_name_factor = [
    { key: '全て', value: '全て' },
    { key: 'GSB', value: 'GSB' },
    { key: 'GSS', value: 'GSS' },
    { key: 'GSMS', value: 'GSMS' },
    { key: 'GS', value: 'GS' },
    { key: 'CRSA', value: 'CRSA' },
    { key: 'CRSB', value: 'CRSB' },
    { key: 'GS9', value: 'GS9' },
];
/** NO店舗マスターショップ因子の入力項目ブランドの初期値 */
export var no_store_checkbox_brand_name_factor = [
    { key: '全て', value: '全て' },
    { key: 'GSB', value: 'GSB' },
    { key: 'GSS', value: 'GSS' },
    { key: 'GSMS', value: 'GSMS' },
    { key: 'Others', value: 'Others' },
];
//CRUD処理の種別
export var crud_type = {
    create: '追加',
    read: '読取り',
    update: '更新',
    delete: '削除',
};
/**
 * 対応する郵便番号のindex値
 * first：array[0]
 * last：array[1]
 */
export var postcode_index = {
    first: 0,
    last: 1,
};
/**
 * 住所検索ダイアログの表示メッセージ
 */
export var address_option = {
    title: '住所検索',
    undefined_body: '該当する郵便番号はありません。',
    auto_input_body: 'が自動入力されました。',
};
// 検索結果ダイアログの初期値
export var search_dialog_init = {
    is_confirm: false,
    details: [],
    show: false,
    title: '',
    body: '',
};
/**
 * 住所検索ダイアログの初期値
 */
export var address_init = {
    form_name: '',
    value: '',
};
//ブランドの初期値
export var shop_factor_sort = [
    { key: '1', value: 'GSB' },
    { key: '2', value: 'GSS' },
    { key: '3', value: 'GSMS' },
    { key: '4', value: 'GS' },
    { key: '5', value: 'CRSA' },
    { key: '6', value: 'CRSB' },
    { key: '7', value: 'GS9' },
];
//備考 field_id
export var remark_field_id = 2100;
/** ユーザの権限ID */
export var user_role_id = {
    /** 製造 */
    production: 1,
    /** DC */
    dc: 2,
    /** 業務（個人情報なし） */
    operation_without_personal_info: 4,
    /** 業務（個人情報あり） */
    operation_with_personal_info: 5,
    /** 参照（個人情報なし） */
    reference_without_personal_info: 6,
    /** 参照（個人情報あり） */
    reference_with_personal_info: 7,
    /** データ連携用ユーザー */
    web_reception: 9,
    /** NO統括 */
    no_supervision: 10,
    /** NO01 */
    no_01: 11,
    /** NO02 */
    no_02: 12,
    /** NO03 */
    no_03: 13,
    /** 【SEIKO】管理者権限 */
    se_admin: 14,
    /** 【SEIKO】登録権限 */
    se_reg: 15,
    /** 【SEIKO】削除権限 */
    se_del: 16,
    /** 【SEIKO】海外NO権限 */
    se_no: 17,
    /** 【SEIKO】参照権限 */
    se_ref: 18,
    /** 【SEIKO】海外営業権限 */
    se_no_sales: 19,
    /** 【SEIKO】海外NO連携権限 */
    se_no_collab: 21,
    /** 業務（STL用） */
    operation_with_stl: 8,
    /** 業務（SCM推進部用） */
    operation_with_scm: 3,
    /** サブシステムのみ利用 */
    only_subsystems: 20,
    /** デバッグユーザ */
    debug: 99,
};
/** ActivationCheckDataの初期値 */
export var activation_check_data_init = {
    warranty_number: '',
    brand: '',
    reference: '',
    caliber: '',
    case: '',
    serial_number: '',
    validity_of_warranty: '',
    warranty_period: '',
    warranty_start_date: '',
    warranty_end_date: '',
};
// 日付選択
export var select_date_type = {
    date_of_purchase: '3', // お買い上げ日
};
// SE権限のrole_id
export var se_role = ['14', '15', '16', '17', '18', '19', '21'];
// NO権限のショップ因子
export var no_shop_factor = [
    { key: "GSB", value: "GSB" },
    { key: "GSS", value: "GSS" },
    { key: "GSMS", value: "GSMS" },
    { key: "Others", value: "Others" }
];
